import { useLayoutEffect, useRef, type ReactNode } from 'react';

// AuditWrapper renders an existing Internal audit page (passed as children)
// but masks any descendant with data-internal-only="true" — used in Internal
// pages to wrap BPX-upsell sections that should not surface in Hub.
//
// Note: this uses useLayoutEffect (not useEffect) so the masking happens
// synchronously before the first paint and the user never sees a flash of
// unmasked content. The inline display:none persists across child re-renders
// as long as the tagged element isn't unmounted-and-remounted by its parent;
// today none of the tagged elements are conditional on internal child state,
// so this is safe.

export function AuditWrapper({ children }: { children: ReactNode }) {
  const ref = useRef<HTMLElement>(null);

  useLayoutEffect(() => {
    const root = ref.current;
    if (!root) return;
    root.querySelectorAll<HTMLElement>('[data-internal-only="true"]').forEach((el) => {
      el.style.display = 'none';
    });
  }, [children]);

  return (
    <section ref={ref}>{children}</section>
  );
}
